module.exports = __webpack_public_path__ + "static/media/nz.0d0a6af0.svg";